export const GITLAB_CLIENT_ID = "1ecb5d595f30aaeafeb4e49f922821461f9443f5226efcc0deca08819e86e88d";
export const GITLAB_BASE_URL = "https://gitlab.cfdata.org";
export const GITLAB_REDIRECT_URI = `${window.location.origin}/callback`;
export const ITEMS_PER_PAGE = 10;
export const REFRESH_INTERVAL = 30 * 1000;
